<div class="row tree-row tree-h">
  <div class="col-12">
    <div class="d-flex">
    <div  class="px-1 tree-btn-1">
      <button type="button" class="tree-btn">
        <i class="fa fa-plus i-add-btn" ></i> 
      </button>
    </div>
    <div  class="pr-1 pl-1">
      <p class="m-0 tree-Content-add pointer-cursor">{{Text}}</p>
    </div> 
    </div>
  </div>
</div>
<!-- 
<div class="row tree-row tree-row-child" *ngIf="Primary == false">
  <div class="col-12">
    <div class="d-flex">
    <div  class="px-1 tree-btn-1">
      <button type="button" class="tree-btn">
        <i class="fa fa-plus i-add-btn" ></i> 
      </button>
    </div>
    <div  class="pr-1 pl-1">
      <p class="m-0 tree-Content-add">{{Text}}</p>
    </div> 
    </div>
  </div>
</div> -->